<div class="conditions">
  <div class="conditions-wrap">
    <h2 [innerHTML]="'CONDITIONS.TITLE' | translate" class="conditions-header"></h2>

    <div class="conditions-accordion">
      <div class="accordion">
        <div class="accordion-header">Кредит, продукт «Зірковий»</div>
        <div class="description">
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.AMOUNT' | translate }}
            </div>
            <div class="description-info">Від 1 000 до 20 000 грн</div>
          </div>
          <div class="description-row">
            <div class="description-label">Комісія за надання кредиту</div>
            <div class="description-info">10% від суми кредиту</div>
          </div>
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.PAY_PERIOD' | translate }}
            </div>
            <div class="description-info">Від 15 до 30 днів</div>
          </div>
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.TERM' | translate }}
            </div>
            <div class="description-info">120 днів</div>
          </div>
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.PERCENT' | translate }}
            </div>
            <div class="description-info">
              Стандартна — 0,9% на день (328,5 річних). Клієнту може бути запропонований індивідуальний промокод для зниження стандартної
              процентної ставки, який діє за умови своєчасного погашення кредиту. Реальна річна процентна ставка - 3035,72% річних (за
              умови, якщо кредит надано без урахування знижок та промокодів). Розрахована, відповідно до Постанови Правління Національного
              банку України 11.02.2021 № 16 з використовуванням функцією XIRR програмного продукту Microsoft Excel.
            </div>
          </div>
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.CLIENT_AGE' | translate }}
            </div>
            <div class="description-info">Від 18 до 70 років</div>
          </div>
          <div class="description-row">
            <div class="description-label">
              {{ 'CONDITIONS.TABLE.GET_OPTIONS' | translate }}
            </div>
            <div class="description-info">Безготівково, на платіжну карту</div>
          </div>
          <div class="description-row">
            <div class="description-label">Необхідне для оформлення онлайн-кредиту</div>
            <div class="description-info">Паспорт, код (BANK ID), дійсна платіжна картка оформлена на ім’я Клієнта, мобільний телефон</div>
          </div>
          <div class="description-row">
            <a
              [href]="documentsUrl + 'Істотні_характеристики_послуги_зі_споживчого_кредиту_Зірковий.pdf'"
              class="description-link"
              download
            >
              Істотні характеристики послуги зі споживчого кредиту Зірковий
            </a>
            <a [href]="documentsUrl + 'Істотні_характеристики_послуги_зі_мікрокредиту_Зірковий.pdf'" class="description-link" download>
              Істотні характеристики послуги зі мікрокредиту Зірковий
            </a>
          </div>
        </div>
      </div>

      <div class="warning warning_accordion">
        <div class="warning-wrap">
          <h2 class="warning-title">ПОПЕРЕДЖЕННЯ</h2>
          <div class="warning-block">
            <p>
              У разі користування кредитом Клієнт бере на себе обов’язок повернути кредит у встановлені договором строки та сплатити
              проценти за користування кредитом
            </p>
            <p>
              У випадку прострочення Клієнтом сплати платежів відповідно до термінів встановлених в Графіку платежів, Товариство нараховує
              неустойку у вигляді штрафу :
            </p>
            <ul>
              <li>
                в розмірі 100 % від суми простроченої заборгованості - на наступний день після терміну сплати, встановленого в Графіку
                платежу, за відповідний розрахунковий (платіжний) період, та до дати погашення заборгованості, з урахуванням обмежень,
                встановленим чинним законодавством України.
              </li>
            </ul>
          </div>
          <div class="warning-block">
            <ul>
              <li>
                У випадку, коли сума кредиту не перевищує розміру однієї мінімальної заробітної плати, неустойка не може перевищувати
                розміру подвійної суми кредиту.
              </li>
              <li>
                У випадку, коли сума кредиту перевищує розмір однієї мінімальної заробітної плати, неустойка не може перевищувати розміру
                половини суми кредиту.
              </li>
              <li>
                У випадку встановлених законодавством України мораторіїв (заборон) на нарахування штрафних санкцій штраф протягом періоду
                мораторію чи заборони не нараховується та відновлюється після їх скасувань
              </li>
              <li>
                у разі затримання Клієнтом сплати частини кредиту та/або процентів щонайменше на один календарний місяць, Товариство має
                право вимагати повернення кредиту, строк виплати якого ще не настав, в повному обсязі відповідно до процедури встановленої
                чинним законодавством України.
              </li>
              <li>
                має право стягнути заборгованість за Договором в примусовому порядку в тому числі та не обмежуючись в судовому порядку,
                відповідно до чинного законодавства України.
              </li>
              <li>
                має право здійснити безспірне списання коштів з банківського рахунку Позичальника для погашення заборгованості відповідно до
                чинного законодавства України.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <table class="conditions-table">
      <thead class="conditions-table-header">
        <tr>
          <th colspan="2">{{ 'CONDITIONS.TABLE.LOAN_TYPE' | translate }}</th>
          <th colspan="10">Кредит, продукт «Зірковий»</th>
        </tr>
      </thead>
      <tbody class="conditions-table-body">
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.AMOUNT' | translate }}</td>
          <td colspan="10">Від 1 000 до 20 000 грн</td>
        </tr>
        <tr>
          <td colspan="2">Комісія за надання кредиту</td>
          <td colspan="10">10% від суми кредиту</td>
        </tr>
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.PAY_PERIOD' | translate }}</td>
          <td colspan="10">Від 15 до 30 днів</td>
        </tr>
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.TERM' | translate }}</td>
          <td colspan="10">120 днів</td>
        </tr>
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.PERCENT' | translate }}</td>
          <td colspan="10">
            Стандартна — 0,9% на день (328,5% річних). Клієнту може бути запропонований індивідуальний промокод для зниження стандартної
            процентної ставки, який діє за умови своєчасного погашення кредиту. Реальна річна процентна ставка - 3369,39% річних (за умови,
            якщо кредит надано без урахування знижок та промокодів). Розрахована, відповідно до Постанови Правління Національного банку
            України 11.02.2021 № 16 з використовуванням функцією XIRR програмного продукту Microsoft Excel.
          </td>
        </tr>
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.CLIENT_AGE' | translate }}</td>
          <td colspan="10">Від 18 до 70 років</td>
        </tr>
        <tr>
          <td colspan="2">{{ 'CONDITIONS.TABLE.GET_OPTIONS' | translate }}</td>
          <td colspan="10">Безготівково, на платіжну карту</td>
        </tr>
        <tr>
          <td colspan="2">Необхідне для оформлення онлайн-кредиту</td>
          <td colspan="10">BANK ID, дійсна платіжна картка оформлена на ім’я Клієнта, мобільний телефон</td>
        </tr>
        <tr style="background: transparent">
          <td colspan="12" style="padding: 0">
            <div class="warning">
              <div class="warning-wrap">
                <h2 class="warning-title">ПОПЕРЕДЖЕННЯ</h2>
                <div class="warning-block">
                  <p>
                    У разі користування кредитом Клієнт бере на себе обов’язок повернути кредит у встановлені договором строки та сплатити
                    проценти за користування кредитом
                  </p>
                  <p>
                    У випадку прострочення Клієнтом сплати платежів відповідно до термінів встановлених в Графіку платежів, Товариство
                    нараховує неустойку у вигляді штрафу :
                  </p>
                  <ul>
                    <li>
                      в розмірі 100 % від суми простроченої заборгованості - на наступний день після терміну сплати, встановленого в Графіку
                      платежу, за відповідний розрахунковий (платіжний) період, та до дати погашення заборгованості, з урахуванням обмежень,
                      встановленим чинним законодавством України.
                    </li>
                  </ul>
                </div>
                <div class="warning-block">
                  <ul>
                    <li>
                      У випадку, коли сума кредиту не перевищує розміру однієї мінімальної заробітної плати, неустойка не може перевищувати
                      розміру подвійної суми кредиту.
                    </li>
                    <li>
                      У випадку, коли сума кредиту перевищує розмір однієї мінімальної заробітної плати, неустойка не може перевищувати
                      розміру половини суми кредиту.
                    </li>
                    <li>
                      У випадку встановлених законодавством України мораторіїв (заборон) на нарахування штрафних санкцій штраф протягом
                      періоду мораторію чи заборони не нараховується та відновлюється після їх скасувань
                    </li>
                    <li>
                      у разі затримання Клієнтом сплати частини кредиту та/або процентів щонайменше на один календарний місяць, Товариство
                      має право вимагати повернення кредиту, строк виплати якого ще не настав, в повному обсязі відповідно до процедури
                      встановленої чинним законодавством України.
                    </li>
                    <li>
                      має право стягнути заборгованість за Договором в примусовому порядку в тому числі та не обмежуючись в судовому
                      порядку, відповідно до чинного законодавства України.
                    </li>
                    <li>
                      має право здійснити безспірне списання коштів з банківського рахунку Позичальника для погашення заборгованості
                      відповідно до чинного законодавства України.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr style="width: 100%">
          <td colspan="6" style="width: 50%">
            <a [href]="documentsUrl + 'Істотні_характеристики_послуги_зі_споживчого_кредиту_Зірковий.pdf'" class="conditions-link" download>
              Істотні характеристики послуги зі споживчого кредиту Зірковий
            </a>
          </td>
          <td colspan="6" style="width: 50%">
            <a [href]="documentsUrl + 'Істотні_характеристики_послуги_зі_мікрокредиту_Зірковий.pdf'" class="conditions-link" download>
              Істотні характеристики послуги зі мікрокредиту Зірковий
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="conditions-calculator" id="landing-calculator">
    <app-calculate [isDetailsOutside]="true"></app-calculate>
  </div>
</div>
